export default __webpack_public_path__ + "static/media/check-circle.cb2ae7d5.svg";